const IconSpreadsheet = ({ className }) => {
    return (
        <svg viewBox='0 0 47 47' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M27.3327 4.70001V16.2H38.8327M15.4183 25.7831L31.5804 25.7315V36.9207L15.4183 36.9723M15.4183 36.9207L15.4183 25.7315M15.4183 31.9994L31.5804 31.9478M20.3912 36.9207V25.7315M28.291 4.70001H11.9993C10.9827 4.70001 10.0077 5.10388 9.28877 5.82277C8.56988 6.54166 8.16602 7.51668 8.16602 8.53335V39.2C8.16602 40.2167 8.56988 41.1917 9.28877 41.9106C10.0077 42.6295 10.9827 43.0333 11.9993 43.0333H34.9993C36.016 43.0333 36.991 42.6295 37.7099 41.9106C38.4288 41.1917 38.8327 40.2167 38.8327 39.2V15.2417L28.291 4.70001Z'
                strokeWidth='2.48649'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconSpreadsheet;
